import React, {Component} from "react";
import {
    Badge,
    Row,
    Col,
    Modal,
    ModalBody,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Card,
    CardHeader,
    CardBody,
    CardFooter,
    CardTitle,
    Button,
    ButtonToolbar,
    ButtonGroup,
    ButtonDropdown,
    Label,
    FormGroup,
    Input,
    Alert,
    Table
} from "reactstrap";
import LoadingIndicator from '../../utils/LoadingIndicator';
import {ajaxWrapperGet, ajaxWrapperPost} from "../../utils/deviceAPI";
import NotificationHOC from "../../components/Notifications/NotificationHOC"
import moment from 'moment'




class Siteinvitations extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            inviteUserEmail: "",
            inviteUserEmailValid: false,
            inviteUserEmailMessage: "",
            inviteUserFormValid: false,
            selectedSite: "none",
            selectedSiteValid: false,
            modalDeleteInvite: false,
            currentUserBeingEdited: 0,
            currentUserBeingEditedFirstName: "",
            currentUserBeingEditedLastName: "",
            currentUserBeingEditedSiteName: ""
        };
        this.handleChange = this.handleChange.bind(this);
        this.inviteNewUserToSite = this.inviteNewUserToSite.bind(this);
        this.formDefaults = this.formDefaults.bind(this);
        this.toggleDelete = this.toggleDelete.bind(this);
        this.deleteInvite = this.deleteInvite.bind(this);
    }
    componentDidMount() {
        this.setData();
    }
    toggleDelete() {
        this.setState({
            modalDeleteInvite: !this.state.modalDeleteInvite
        });
    }
    setData() {
        ajaxWrapperGet('/api/user/siteInvites').then((data) => {
            this.setState({
                data,
                loading: false
            });

        });
    }
    userBeingEdited(id = 0, firstName = "", lastName = "", siteName = "") {
        this.setState({
            currentUserBeingEdited: id,
            currentUserBeingEditedFirstName: firstName,
            currentUserBeingEditedLastName: lastName,
            currentUserBeingEditedSiteName: siteName
        });
    }
    handleChange({ target }) {
        const name = target.name;
        const value = target.value;
        this.setState({
                [name]: value
            },
            () => { this.validateField(name, value) }

        );
    }
    deleteInvite() {
        let postData = {
            id: this.state.currentUserBeingEdited,
            firstName: this.state.currentUserBeingEditedFirstName,
            lastName: this.state.currentUserBeingEditedLastName,
            siteName: this.state.currentUserBeingEditedSiteName
        };
        ajaxWrapperPost('/api/user/deleteSiteInvite',postData).then((data) => {
            if (data.error === false) {
                this.refs.notification.notify(data.message,'success');
                this.toggleDelete();
                this.setData();
            }
            else if (data.error === true) {
                this.refs.notification.notify(data.message,'error');
            }
        });
    }
    formDefaults() {
        this.setState({
            inviteUserEmail: "",
            inviteUserEmailValid: false,
            inviteUserEmailMessage: "",
            inviteUserFormValid: false,
            selectedSite: "none",
            selectedSiteValid: false
        });
    }
    inviteNewUserToSite() {
        let postData = {
            siteid: this.state.selectedSite,
            email:this.state.inviteUserEmail
        };


        ajaxWrapperPost(`/api/user/sendSiteInvite`,postData).then((data) => {
            if (data.error === false) {
                this.refs.notification.notify(`Successfully invited ${this.state.inviteUserEmail}.`,'success');
                this.formDefaults();
                this.setData();
            }
            else if (data.error === true) {
                this.refs.notification.notify(data.message,'error');
            }
        });

    }

    validateField(fieldName, value) {
        let _emailValid = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;
        let _inviteUserEmailValid = this.state.inviteUserEmailValid;
        let _inviteUserEmailMessage = this.state.inviteUserEmailMessage;
        let _selectedSite = this.state.selectedSite;
        let _selectedSiteValid = this.state.selectedSiteValid;

        switch(fieldName) {
            case 'inviteUserEmail':
                if (!_emailValid.test(value)) {
                    _inviteUserEmailValid = false;
                    _inviteUserEmailMessage = "Invalid Email";
                }
                else {
                    _inviteUserEmailValid = true;
                    _inviteUserEmailMessage = "";

                }
                break;
            case 'selectedSite':
                _selectedSiteValid = value !== 'none';
                break;
        }
        this.setState({
            inviteUserEmailValid:_inviteUserEmailValid,
            inviteUserEmailMessage:_inviteUserEmailMessage,
            selectedSite: _selectedSite,
            selectedSiteValid:_selectedSiteValid,
            inviteUserFormValid: _inviteUserEmailValid && _selectedSiteValid,

        });
    }


    render() {
        if (this.state.loading) {
            return <LoadingIndicator />;
        }
        //console.log(this.state.data);
        return (
            <div className="animated fadeIn">
                <NotificationHOC ref="notification"/>
                <Row>
                    <Col xs="12" lg="4">
                        <Card>
                            <CardBody className="card-body">
                                <Row className="pb-4">
                                    <Col sm="12">
                                        <CardTitle className="mb-1">Send Invite</CardTitle>
                                        <div className="small text-muted">send an invitation to a registered user to join a site you have administrative privileges</div>
                                    </Col>
                                </Row>
                                <Row className="pb-2">
                                    <Col sm="12">
                                        <FormGroup row>
                                            <Col md="3">
                                                <Label htmlFor="select">Select</Label>
                                            </Col>
                                            <Col xs="12" md="9">
                                                <Input type="select" name="selectedSite" id="selectedSite" value={ this.state.selectedSite } onChange={ this.handleChange }>
                                                    <option value="none" defaultValue >None</option>
                                                    {this.state.data.userAccessList.map((sites,index) =>{
                                                        return <option key={index} value={sites.id}>{sites.siteName}</option>
                                                    })}
                                                </Input>
                                            </Col>
                                        </FormGroup>
                                        <FormGroup row>
                                            <Col md="3">
                                                <Label htmlFor="select">E-Mail</Label>
                                            </Col>
                                            <Col xs="12" md="9">
                                                <Input type="email" id="addNewUseremail" name="inviteUserEmail" className={this.state.inviteUserEmailValid ? "is-valid" : "is-invalid"} placeholder="Enter User's Email" value={ this.state.inviteUserEmail } onChange={ this.handleChange } required/>
                                                {this.state.inviteUserEmailMessage.length <= 0 ? "" :
                                                    <div className="invalid-feedback" id="passwordError" >{this.state.inviteUserEmailMessage}</div>
                                                }
                                            </Col>
                                        </FormGroup>
                                        <FormGroup row>
                                            <Col md="6">
                                            </Col>
                                            <Col md="6">
                                                <Button color="primary" onClick={this.inviteNewUserToSite} className="mt-3 btn btn-block" disabled={!this.state.inviteUserFormValid}>
                                                    Send Invite
                                                </Button>
                                            </Col>
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                    <Col xs="12" lg="8">
                        <Card>
                            <CardBody className="card-body">
                                <Row className="pb-4">
                                    <Col sm="12">
                                        <CardTitle className="mb-1">Pending Invites Sent</CardTitle>
                                        <div className="small text-muted">list of current site pending invites sent to other users</div>
                                    </Col>
                                </Row>
                                <Row className="pb-2">
                                    <Col xs="12" sm="12" lg="12" xl="12" className="mb-1">
                                        <ul className="icons-list mb-5 list-inline">
                                            {this.state.data.pendingInvites.map((invite,index) => {
                                                    return (
                                                        <li key={index} className="mb-3 mt-3 listSiteItems">
                                                            <i className={"fa fa-arrow-circle-right"}></i>
                                                            <div className="desc-n">
                                                                <div className="title">{invite.firstname} {invite.lastname}</div>
                                                                <div className="small text-muted text-lowercase pb-3">invitation sent {moment(invite.invitationDateTime).format('MM/DD/YY - hh:mm:ss A')}</div>
                                                            </div>
                                                            <div className="value mr-4">
                                                                <div className="small text-muted">Site</div>
                                                                <div className="small text-info">{invite.siteName}</div>
                                                            </div>
                                                            <div className="actions">
                                                                <Button color="link" className="text-danger" onClick={() => {this.toggleDelete(); this.userBeingEdited(invite.id,invite.firstname,invite.lastname,invite.siteName);}}><i className="fa fa-trash"></i></Button>
                                                            </div>
                                                        </li>
                                                    );
                                                }
                                            )}
                                            {this.state.data.pendingInvites.length === 0 ? <Alert color="secondary" ><small>You currently don't have any sent site invites.</small></Alert>:""}
                                        </ul>
                                    </Col>
                                    <Modal isOpen={this.state.modalDeleteInvite} toggle={this.toggleDelete} >

                                        <ModalBody>
                                            <Row>
                                                <Col sm="10">
                                                    <CardTitle className="mb-1">Delete Invite</CardTitle>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col sm="12">
                                                    <hr className="mb-4"/>
                                                </Col>
                                            </Row>
                                            <Row className="pb-2">
                                                <Col sm="12">
                                                    <div className="text-center">Are you sure you want to delete the pending invite for {this.state.currentUserBeingEditedFirstName} {this.state.currentUserBeingEditedLastName} to site {this.state.currentUserBeingEditedSiteName} ?</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col sm="12">
                                                    <hr className="mb-4"/>
                                                </Col>
                                            </Row>
                                            <Row className="pb-4">
                                                <Col sm="6" className="small text-muted">
                                                    <Button color="link" className="btn btn-block" onClick={this.toggleDelete}>Cancel</Button>
                                                </Col>
                                                <Col sm="6" className="small text-muted">
                                                    <Button color="danger" className="btn btn-block" onClick={this.deleteInvite} >Delete</Button>
                                                </Col>
                                            </Row>
                                        </ModalBody>
                                    </Modal>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        )
    }
}


export default Siteinvitations;



// WEBPACK FOOTER //
// ./src/views/Invitations/Siteinvitations.js